module.exports = __webpack_public_path__ + "img/avatar_06.3e27c5a4.webp";